export enum ETableTabItemTypes {
  OPEN_APPLICANTS = 'Open applicants',
  SUBMITTED_APPLICANTS = 'Submitted applicants',
  ARCHIVED_APPLICANTS = 'Archived applicants'
}
